import React, { useState, useEffect } from "react";
import { List, Typography, Space } from 'antd';
import { blue, magenta} from '@ant-design/colors'

const { Text } = Typography;

export default function PreGroup() {
    const [rsvp_list, setRsvpList] = useState([])
    const [husband_list, setHusbandList] = useState([])
    const [wife_list, setWifeList] = useState([])
    
    useEffect(() => {

        if(husband_list.length === 0 && wife_list.length === 0 && rsvp_list.length === 0){
            fetch('/list/group', {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            })
            .then(async response => await response.json())
            .then(data => {
                let hlist = [], wlist = [], blist = []
                for(let title in data.datas){
                    const child = data.datas[title]
                    let total = 0
                    let seat = ''
                    child.map(item => {total += Number(item.count); seat = item.seat})
                    if(title !== ''){
                        if(title[0].toLowerCase() === 'h'){
                            hlist.push({title,seat,total,child});
                        }else if(title[0].toLowerCase() === 'w'){
                            wlist.push({title,seat,total,child});
                        }else{
                            blist.push({title,seat,total,child});
                        }
                    }
                    // console.log(title,child)
                }
                hlist.sort((a,b) => Number(a.title.slice(1)) - Number(b.title.slice(1)))
                setHusbandList(hlist)
                wlist.sort((a,b) => Number(a.title.slice(1)) - Number(b.title.slice(1)))
                setWifeList(wlist)
                setRsvpList(blist)
            })
            .catch(err => {
                console.log(err)
            })
        }
        console.log('check point 2')
    },[rsvp_list])

    const ListRender = ({datasources, header}) => {
        return (
            <List
                grid={{ 
                    gutter: 10, 
                    xs: 1,
                    sm: 2,
                    md: 4,
                    lg: 4,
                    xl: 6,
                    xxl: 10,
                }}
                header={header}
                dataSource={datasources}
                size="small"
                renderItem={(item) => (
                    <List 
                        style={{height:'99%', margin:'5px'}}
                        dataSource={item.child}
                        bordered={true}
                        header={<h3>{item.title} ({item.seat}) - {item.total}人</h3>}
                        renderItem={(item, index) => (
                            <List.Item>
                                <Space direction="vertical">
                                    <Text strong style={{color:(item.label[0] === 'h' ? blue[7] : magenta[8])}}>{item.name} - {item.count}</Text>
                                    <Text italic  style={{color:(item.label[0] === 'h' ? blue[5] : magenta[4])}}>{item.tag}</Text>
                                </Space>
                            </List.Item>
                        )}
                    ></List>
                )}
            />
        )
    }

    return (
        <div>
            <ListRender
                header={<h2>Husband Groups</h2>}
                datasources={husband_list}
            ></ListRender>

            <ListRender
                header={<h2>Wife Groups</h2>}
                datasources={wife_list}
            ></ListRender>

            <ListRender
                header={<h2>Join Groups</h2>}
                datasources={rsvp_list}
            ></ListRender>
            
        </div>
    );
}

